import DiscordIcon from "../assets/icons/socials/discord.svg";
import YoutubeIcon from "../assets/icons/socials/youtube.svg";
import TelegramIcon from "../assets/icons/socials/telegram.svg";
import { PUBLIC_CONFIG_KEYS } from "./publicConfig";

const VOTE_SERVER_URL = "https://dayz-servers.org/server/183184/vote/";

export const APP_SOCIAL_LINKS = [
  {
    key: "discord",
    label: "Discord",
    configKey: PUBLIC_CONFIG_KEYS.discordUrl,
    icon: DiscordIcon,
  },
  {
    key: "youtube",
    label: "YouTube",
    configKey: PUBLIC_CONFIG_KEYS.youtubeUrl,
    icon: YoutubeIcon,
  },
  {
    key: "twitter",
    label: "Twitter/X",
    configKey: PUBLIC_CONFIG_KEYS.twitterUrl,
    icon: null,
  },
  {
    key: "telegram",
    label: "Telegram",
    configKey: PUBLIC_CONFIG_KEYS.telegramUrl,
    icon: TelegramIcon,
  },
];

export const getConfiguredSocialLinks = (config) =>
  APP_SOCIAL_LINKS.filter(({ configKey }) => typeof config?.[configKey] === "string")
    .map(({ configKey, ...social }) => ({
      ...social,
      href: config[configKey],
    }));

export const getDiscordHelpUrl = (config) =>
  typeof config?.[PUBLIC_CONFIG_KEYS.discordUrl] === "string"
    ? config[PUBLIC_CONFIG_KEYS.discordUrl]
    : null;

export const APP_LINKS = {
  voteServer: VOTE_SERVER_URL,
};
